<template>
    <div class="row align-items-center justify-content-end mt-4 mx-n2">
        <div class="col-auto px-2">
            <button class="btn btn-link" type="button" @click="handleCancelClicked">
                Annuler
            </button>
        </div>
        <div class="col-auto px-2">
            <button class="btn btn-primary" :class="{ 'btn-lg': large }" type="submit" :disabled="loading">
                <template v-if="loading">
                    Envoi...
                </template>
                <template v-else>
                    {{ submitLabel }}
                </template>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props:  {
            loading: Boolean,
            submitLabel: {
                type: String,
                default: 'Envoyer',
            },
            large: Boolean,
        },
        methods: {
            handleCancelClicked() {
                this.$emit('cancel');
            }
        }
    }
</script>
